import { forwardRef } from 'react';
import { DeckardIcon, DeckardIconProps } from './DeckardIcon';

export const Outline2DIcon: DeckardIcon = forwardRef<SVGSVGElement, DeckardIconProps>(
  ({ circle, double, size = 24, color = 'currentColor', ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      color={color}
      className="deckard-icon"
      {...props}
    >
      <rect x="4.27271" y="4.27295" width="15.4545" height="15.4545" stroke="currentColor" />
      <circle cx="4.5" cy="4.5" r="2.5" fill="currentColor" />
      <circle cx="19.5" cy="4.5" r="2.5" fill="currentColor" />
      <circle cx="4.5" cy="19.5" r="2.5" fill="currentColor" />
      <circle cx="19.5" cy="19.5" r="2.5" fill="currentColor" />
    </svg>
  ),
);
